
































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  BIcon,
  BIconEnvelope,
  BIconGeoAlt,
  BIconList,
  BIconDiamond,
} from "bootstrap-vue";

@Component({
  components: {
    BIcon,
    BIconEnvelope,
    BIconGeoAlt,
    BIconList,
    BIconDiamond,
  },
})
export default class Footer extends Vue {
  // export default==protected class
}
